import { Component, EventEmitter, Input, Output } from '@angular/core';
import {MatIconRegistry, MatIconModule} from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
@Component({
  selector: 'ngx-card',
  templateUrl: './base-card.component.html',
  styleUrls: ['./base-card.component.scss']
})
export class BaseCardComponent {
  
  @Input() title!: string;
  @Input() icon!: string;
  @Input() svgicon!: string;
  @Input() imgicon!: string;
  @Input() bgcolor!: string;
  @Input() cardClass!: string;
  @Input() wrapperClass!: string;
  @Input() contentClass!: string;
  @Input() helpTitle?: string;
  @Input() helpDescription?: string;
  
  constructor(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer){
    if (this.svgicon) {
      iconRegistry.addSvgIcon(
        'svg_icon',
        sanitizer.bypassSecurityTrustResourceUrl('assets/icons/' + this.svgicon+'.svg')
      );
    }
  }
  ngOnInit(): void {
    
  }
}